import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(4),
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 800,
  margin: '0 auto',
}));

export const Header = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SettingsCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  marginBottom: theme.spacing(3),
}));

export const SettingSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const SettingRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const SettingInfo = styled(Box)(({ theme }) => ({
  flex: 1,
}));
